import { createAsyncThunk } from '@reduxjs/toolkit'
import CustomerSettings from './customer-settings-model'
import {
  delete_customerSettings,
  load_customerSettingss,
  store_customerSettings,
} from './customerSettings-service'

export const LoadCustomerSettingssAsync = createAsyncThunk<any, any>(
  'composer/load/customerSettings',
  async (params: { uid: string }) => {
    return await load_customerSettingss(params)
  },
)

export const CreateCustomerSettingsAsync = createAsyncThunk<any, any>(
  'composer/create/customerSettings',
  async (params: CustomerSettings) => {
    return await store_customerSettings(params)
  },
)

export const DeleteCustomerSettingsAsync = createAsyncThunk<any, any>(
  'composer/delete/customerSettings',
  async (params) => {
    return await delete_customerSettings(params)
  },
)
